import * as React from 'react'
import { FaLinkedin } from 'react-icons/fa'

const Social = ({ links }) => (
	<ul className="mt-4 text-2xl">
		{links?.map((link, i) => (
			<li key={i}>
				<a href={link} target="_blank" rel="noopener noreferrer">
					{link.includes('linkedin') ? <FaLinkedin /> : null}
				</a>
			</li>
		))}
	</ul>
)

export default Social
